import { render, staticRenderFns } from "./OrganizationsLocationsForm.vue?vue&type=template&id=4bb518cd&scoped=true&"
import script from "./OrganizationsLocationsForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationsLocationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb518cd",
  null
  
)

export default component.exports